import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { flags } from '../assets/flags';
import { useCountry } from '../contexts/CountryContext';
import '../styles/CountrySelector.css';

const CountrySelector = () => {
  const { t } = useTranslation();
  const { selectedCountry, changeCountry } = useCountry();
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  const countryOptions = [
    { code: 'BR', language: 'pt' },
    { code: 'PT', language: 'pt' },
    { code: 'US', language: 'en' },
    { code: 'GB', language: 'en' },
    { code: 'FR', language: 'fr' },
    { code: 'IT', language: 'it' },
    { code: 'ES', language: 'es' },
    { code: 'DE', language: 'de' },
    { code: 'NL', language: 'nl' }
  ];

  const handleCountryChange = (countryCode) => {
    changeCountry(countryCode);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="country-selector" ref={selectRef}>
      <div 
        className="country-select-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div 
          className="flag-svg"
          dangerouslySetInnerHTML={{ __html: flags[selectedCountry] }}
        />
        {/*<span className="country-name">{countries[selectedCountry].name}</span>*/}
        <span className={`arrow ${isOpen ? 'up' : 'down'}`}>▼</span>
      </div>
      
      {isOpen && (
        <div className="country-options">
          {countryOptions.map((country) => (
            <div
              key={country.code}
              className={`country-option ${selectedCountry === country.code ? 'active' : ''}`}
              onClick={() => handleCountryChange(country.code)}
            >
              <div 
                className="flag-svg"
                dangerouslySetInnerHTML={{ __html: flags[country.code] }}
              />
              {/*<span className="country-name">{countries[country.code].name}</span>*/}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountrySelector; 